(() => {
  const desktop = matchMedia('(min-width:990px)');
  let cleanup;
  function init() {
    cleanup?.();
    const header = document.querySelector('.section-header');
    if (!header) return;
    const spacer = document.createElement('div');
    spacer.className = 'akuma-header-spacer'; spacer.setAttribute('aria-hidden','true');
    header.before(spacer);
    const countdowns = [...document.querySelectorAll('[id^="AkumaClosingBar-"]')].map(bar => {
      const wrapper = bar.closest('.shopify-section');
      if (!wrapper) return null;
      const gap = document.createElement('div'); gap.className = 'akuma-header-spacer'; gap.setAttribute('aria-hidden','true');
      wrapper.before(gap); wrapper.classList.add('akuma-countdown-fixed');
      return {bar, wrapper, gap};
    }).filter(Boolean);
    let frame;
    const update = () => {
      frame = null;
      let countdownHeight = 0;
      countdowns.forEach(({wrapper, gap}) => {
        wrapper.style.setProperty('--akuma-countdown-top', countdownHeight + 'px');
        const height = getComputedStyle(wrapper).visibility === 'hidden' ? 0 : wrapper.getBoundingClientRect().height;
        gap.style.height = height + 'px'; countdownHeight += height;
      });
      document.documentElement.style.setProperty('--akuma-closing-offset', countdownHeight + 'px');
      if (!desktop.matches) {
        header.classList.remove('akuma-header-fixed'); spacer.style.height = '0px';
        return;
      }
      // Keep the full visible announcement between the countdown and navigation.
      // Once it scrolls behind the countdown, the two fixed bars meet exactly.
      let top = countdownHeight;
      document.querySelectorAll('.announcement-bar-section').forEach(announcement => {
        const style = getComputedStyle(announcement);
        const box = announcement.getBoundingClientRect();
        if (style.display !== 'none' && style.visibility !== 'hidden' && box.height > 0) {
          top = Math.max(top, box.bottom);
        }
      });
      spacer.style.height = header.getBoundingClientRect().height + 'px';
      header.style.setProperty('--akuma-header-visible-top', top + 'px');
      header.classList.add('akuma-header-fixed');
      header.classList.toggle('akuma-desktop-scrolled', window.scrollY > 4);
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    const resize = new ResizeObserver(schedule); resize.observe(header);
    document.querySelectorAll('[id^="AkumaClosingBar-"], .announcement-bar-section').forEach(el => resize.observe(el));
    window.addEventListener('scroll',schedule,{passive:true}); window.addEventListener('resize',schedule);
    desktop.addEventListener('change',schedule); update();
    cleanup = () => { cancelAnimationFrame(frame); resize.disconnect(); window.removeEventListener('scroll',schedule); window.removeEventListener('resize',schedule); desktop.removeEventListener('change',schedule); header.classList.remove('akuma-header-fixed'); spacer.remove(); countdowns.forEach(({wrapper,gap}) => {wrapper.classList.remove('akuma-countdown-fixed'); wrapper.style.removeProperty('--akuma-countdown-top'); gap.remove();}); };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
})();